<div>
    <n-data-table
        #dt
        [columnDefs]="tableColumnDefs"
        [config]="tableConfig"
        [data]="lunsList"
        [id]="'lun-member-table' + data.hostId"
        [loading]="loading"
        class="infigo-mapping-member-lun-expand">
    </n-data-table>
</div>

<ng-template #nameTemp let-data="rowData">
  <app-mapping-lun-link [data]="data" (clickItem)="setRouterPath($event)" name="lunName"></app-mapping-lun-link>
</ng-template>
